<template>

    <div
        v-if="(authenticated && activeUser) || self_install" 
        :style="``"
    >
        <div id="app" style="padding: 0px">
            <k-nav-bar :userData="userData" @logOut="logOut"/>
            <div style="margin-top: 80px">
                <b-alert v-model="alert.show" :variant="alert.variant" dismissible id="root-alert">
                    {{alert.message}}
                </b-alert>
                    <router-view
                        :userData="userData"
                        @setAuthenticated="setAuthenticated"
                        @showAlert="showAlert"
                        @closeAlert="closeAlert"
                    />
                <k-footer-menu/>
            </div>
        </div>
    </div>

    <div 
        id="registration_container"    
        v-else-if="authenticated && !activeUser" 
        :style="`
            padding:64px 0px;
            background-size: contain;
            min-height: 100vh;
        `"
    >
        <div id="app" style="padding: 0px">
            <k-nav-bar :userData="userData" @logOut="logOut"/>
            <div style="margin-top: 80px">
                <registration @activate_user="activate_user" @logOut="logOut"/>
            </div>
        </div>
    </div>

    <div
        v-else 
        id ="login_top"
        :style="`
            min-height: 100vh;
            background-size: contain;
            overflow: hidden
        `"
        >
        <SelfInstall 
            v-if="self_install"
            @setAuthenticated="setAuthenticated"
            @auth_navigation="auth_navigation"
            @activate_user="activate_user"
        />
        <Login
            v-else-if="!self_install && !creating_account"
            @setAuthenticated="setAuthenticated"
            @auth_navigation="auth_navigation"
            @activate_user="activate_user"
        />
        <ForgotPassword
            v-else
            @setAuthenticated="setAuthenticated"
            @auth_navigation="auth_navigation"
        />
    </div>

</template>

<script>

    import Registration from './components/Registration/Registration'
    import ForgotPassword from './components/ForgotPassword'
    import KFooterMenu from './widgets/FooterMenu'

    import 'ui-common/dist/lib/ui-common.min.css'
    import KNavBar from './widgets/NavBar'
    import Login from './components/Login'
    import SelfInstall from './components/Verification/SelectDevice'
    
    export default {

        name: 'App',
        components:{
            Login,
            KNavBar,
            KFooterMenu,
            Registration,
            ForgotPassword,
            SelfInstall
        },
        
        mounted() {
            this.authenticated = this.h_is_jwt_token_valid();
            this.activeUser = localStorage.getItem('active_user') == "true";
            this.userData = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null
            this.self_install = localStorage.getItem('self_install_user') == "true";
        },
        data() {
            return {
                userData: null,
                authenticated: false,
                creating_account: false,
                activeUser: false,
                self_install: false,

                alert: {
                    show: false,
                    message: '',
                    variant: ''
                }
            }
        },

        methods: {
            setAuthenticated(status, userData) { 
                this.authenticated = status
                this.userData = userData
            },

            activate_user(bool){ this.activeUser = bool },
            auth_navigation(bool){ this.creating_account = bool },
            logOut() {
                localStorage.clear()
                window.location.replace("http://konametrix.com")
            },

            showAlert(msg, variant, autoclose) {
                this.alert.show = true
                this.alert.message = msg
                this.alert.variant = variant
                autoclose ? setTimeout(() => this.closeAlert(), autoclose) : null
            },

            closeAlert() {
                this.alert.show = false
                this.alert.message = ''
                this.alert.variant = ''
            },

            selfInstall() {
                this.authenticated = true
            }
        }
    }

</script>

<style>

    /*===========================
        Default
    ===========================*/
    body{
        font-family: 'Roboto', sans-serif;
    }
    h1, h2, h3, h4, h5 {
        color: #545454;
    }
    p{
        color: #black;
    }

    a{
       color: #296A9B !important
    }

    .navbar {
        top: 0;
        z-index: 999;
        position: fixed !important;
        width: 100%;
        background: black !important;
    }

    /*===========================
     Header
    ===========================*/
    .hero{
        min-height: 250px;
        background: #469BC7;
        background: linear-gradient(0deg, #296A9B 0%, black 100%);
        color: #fff;
    }
    .hero-content{
        margin-top: 25px;
    }

    .btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .btn-outline-primary.dropdown-toggle {
        color: #000 !important;
        background-color: #296a9b !important;
        border-color: black !important;
        color: white !important
    }

    .btn-outline-primary {
        color: black !important;
        border-color: black !important;
    }

    .btn-outline-primary:hover {
        color: #fff !important;
        background-color: grey !important;
        border-color: black !important;
    }

    /*.btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .btn-outline-primary.dropdown-toggle {*/
    /*    color: #fff !important;*/
    /*    background-color: #296a9b !important;*/
    /*    border-color: #296a9b !important;*/
    /*}*/

    /*.btn-outline-primary {*/
    /*    color: #fff !important;*/
    /*    color: #296a9b !important;*/
    /*    border-color: #296a9b !important;*/
    /*}*/

    /*===========================
     Footer
    ===========================*/
    .footer{
        background: #000;
        padding-top: 30px;
        color: #fff;
    }
    .footer a{
        color: #fff !important;
    }
    .footer a:hover{
        color: #d2d2d2;
    }
    .copyright{
        font-size: 10px;
    }

    /*===========================
     Backgrounds Colored
    ===========================*/
    .bg-light-blue{
        background-color: #296A9B !important;
    }
    .bg-black{
        background-color: #000 !important;
    }


    .modal-body {
        padding: 3rem !important;
    }
    /*===========================
     Icons with Colored Backgrounds
    ===========================*/
    .device-active{
        height: 25px;
        width: 25px;
        background-color: #00a716;
    }
    .device-inactive{
        height: 25px;
        width: 25px;
        background-color: #C94848;
    }
    .icon-close{
        height: 25px;
        width: 25px;
        background-color: #000;
    }
    .icon-red {
        border: 3px solid #C94848;
        background-color: #C94848;
        border-radius: 50%;
        width: 40px;
        height: 40px;
        overflow: hidden;
        padding: 10px;
        left: 10px;
        top: 10px;
        /* new */
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .icon-blue {
        border: 3px solid #296a9b;
        background-color: #296a9b;
        border-radius: 50%;
        width: 30px;
        height: 30px;
        overflow: hidden;
        padding: 10px;
        left: 10px;
        top: 10px;
        /* new */
        display: flex;
        justify-content: center;
        align-items: center;
    }

    /*===========================
     WaterNumber
    ===========================*/

    .water-number-inner-good{
        height: 150px;
        width: 150px;
        background-color: #00a716;
    }
    .water-number-outer-good{
        height: 250px;
        width: 250px;
        background-color: #00A716;
    }
    .water-number-outermost-good{
        height: 300px;
        width: 300px;
        background-color: #C1DDBD;
    }


    /*===========================
     Boxes
    ===========================*/
    .boxes-hero{
        margin-top: -100px;
    }
    .box{
        min-height: 200px;
        border-radius: 8px;
        height: 100%;
        border: none !important;
    }
    .box-active{
        border-top: 10px solid #00a716 !important;
    }
    /* Card Overrides*/
    .box-header{
        border-radius: none !important;
        color: #fff;
        font-size: 20px;
    }
    .box-header-bg-{
        background: #ECF6FB !important;
        border-radius: none !important;
        color: #545454;
        font-size: 20px;
    }
    .box-body {
        color: #747474;
    }

    /*===========================
     Backgrounds with Icons
    ===========================*/
    .bg-icon-device{
        background: url('/icons/icon-device-bg.png') no-repeat bottom right;
        background-size: 163.58px 150px;
    }
    .bg-icon-location{
        background: url('/icons/icon-location-bg.png') no-repeat bottom right;
        background-size: 131.72px 150px;
    }
    .bg-icon-customer{
        background: url('/icons/icon-customer-bg.png') no-repeat bottom right;
        background-size: 125px 150px;
    }

    /*===========================
     Tabs
    ===========================*/

    .tabs-data{
        margin-top: 50px;
        margin-bottom: 100px;
    }

    .tabs-header{
        background: #296a9b;
        background: linear-gradient(90deg, rgba(78,173,222,1) 0%, rgba(38,117,186,1) 100%);
    }

    .tabs-header a{
        color: #fff;
    }
    /*Tabs Override*/
    .nav-pills .nav-link.active, .nav-pills .show>.nav-link{
        background-color: transparent !important;
        border-bottom: 2px solid #1A5181;
        border-radius: 0px !important;
    }

    /*===========================
     Tables
    ===========================*/
    .table{
        color: #747474;
    }
    .thead-light-blue{
        background: #F1F6FA;
        border: none !important;
    }
    /* Table Overrides */
    .table thead th{
        border-bottom: none !important;
    }
    .table td, .table th{
        border-top: none !important;
    }

    /*===========================
     Buttons
    ===========================*/
    .btn{
        /*border-radius: 40px !important;*/
    }

    .btn-blue{
        background-color: #3B83C0;
        color: #fff;
    }
    .btn-green{
        background-color: #00a716;
        color: #fff !important;

    }
    .btn-green:hover{
        background-color: #249452;
        color: #fff !important;

    }
    /* Text Colors */
    .text-blue{
        color: #3B83C0;
    }

    .text-green{
        color: #00a716;
    }

    /*===========================
     Log In Page
    ===========================*/
    .login,
    .image {
        min-height: 100vh;
    }

    .dropdown-toggle {
        background-color: black !important
    }
    
    .bg-image {
        background-image: url('/login-bg.png');
        background-size: cover;
        background-position: center;
    }

    .login-heading {
        font-weight: 300;
    }

    .btn-login {
        font-size: 0.9rem;
        letter-spacing: 0.05rem;
        padding: 0.75rem 1rem;
        border-radius: 2rem;
    }

    .form-label-group {
        position: relative;
        margin-bottom: 1rem;
    }

    .form-label-group>input,
    .form-label-group>label {
        padding: var(--input-padding-y) var(--input-padding-x);
        height: auto;
        border-radius: 2rem;
    }

    .form-label-group>label {
        position: absolute;
        top: 0;
        left: 0;
        display: block;
        width: 100%;
        margin-bottom: 0;
        /* Override default `<label>` margin */
        line-height: 1.5;
        color: #495057;
        cursor: text;
        /* Match the input under the label */
        border: 1px solid transparent;
        border-radius: .25rem;
        transition: all .1s ease-in-out;
    }

    .form-label-group input::-webkit-input-placeholder {
        color: transparent;
    }

    .form-label-group input:-ms-input-placeholder {
        color: transparent;
    }

    .form-label-group input::-ms-input-placeholder {
        color: transparent;
    }

    .form-label-group input::-moz-placeholder {
        color: transparent;
    }

    .form-label-group input::placeholder {
        color: transparent;
    }

    .form-label-group input:not(:placeholder-shown) {
        padding-top: calc(var(--input-padding-y) + var(--input-padding-y) * (2 / 3));
        padding-bottom: calc(var(--input-padding-y) / 3);
    }

    .form-label-group input:not(:placeholder-shown)~label {
        padding-top: calc(var(--input-padding-y) / 3);
        padding-bottom: calc(var(--input-padding-y) / 3);
        font-size: 12px;
        color: #777;
    }

    /*===========================
     Fallback Edge - Who uses edge?
    ===========================*/

    @supports (-ms-ime-align: auto) {
        .form-label-group>label {
            display: none;
        }
        .form-label-group input::-ms-input-placeholder {
            color: #777;
        }
    }

    /*===========================
     Fallback Explorer - Who uses explorer?
    ===========================*/

    @media all and (-ms-high-contrast: none),
    (-ms-high-contrast: active) {
        .form-label-group>label {
            display: none;
        }
        .form-label-group input:-ms-input-placeholder {
            color: #777;
        }
    }



    /*===========================
      Billing
    ===========================*/

    .price-active {
        background-color: #00a716 !important;
        color: white;
    }


    .toggle, .toggler {
        display: inline-block;
        vertical-align: middle;
        margin: 10px;
    }

    .toggler {
        color: #ddd;
        transition: .2s;
        font-weight: bold;
    }

    .toggler--is-active {
        color: #00a716;
    }

    .b {
        display: block;
    }

    .toggle {
        position: relative;
        width: 80px;
        height: 35px;
        border-radius: 100px;
        background-color: #00a716;
        overflow: hidden;
        box-shadow: inset 0 0 2px 1px rgba(0, 0, 0, 0.05);
    }

    .check {
        position: absolute;
        display: block;
        cursor: pointer;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        z-index: 6;
    }

    .check:checked ~ .switch {
        right: 2px;
        left: 57.5%;
        transition: 0.25s cubic-bezier(0.785, 0.135, 0.15, 0.86);
        transition-property: left, right;
        transition-delay: .08s, 0s;
    }

    .switch {
        position: absolute;
        left: 2px;
        top: 2px;
        bottom: 2px;
        right: 57.5%;
        background-color: #fff;
        border-radius: 36px;
        z-index: 1;
        transition: 0.25s cubic-bezier(0.785, 0.135, 0.15, 0.86);
        transition-property: left, right;
        transition-delay: 0s, .08s;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
    }


    /*===========================
      Navigation
    ===========================*/

    .accounts-submenu-wrapper {
        position: absolute;
        padding-right: 2rem;
        left: calc(-100% + 2rem);
        top: 0;
        display: none;
        font-size: 14px;

    }

    .navbar-nav{
        flex-direction: row !important;
    }

    .navbar-nav .nav-link{
        padding: .5rem 0.5rem  !important;
    }

    .navbar {
        background: black !important;
        flex-wrap: nowrap;
    }

    .navbar-brand{
        padding: 0;
        width: 180px;
        margin: 0;
    }

    .navbar-search input {
        background:black;
        color:white;
        border-radius: 50px;
    }
    .navbar-search input::placeholder {
        color:white;
    }
    .navbar-dark .navbar-nav .nav-link {
        color: rgba(255, 255, 255, 1);
    }

    .navbar-search input:focus {
        color: #fff;
        background-color: #000;
        border-color: #fff;
        outline: 0;

    }

    .accounts-submenu {
        border-radius: .25rem;
        padding-top: .25rem;
        box-shadow: 1px 5px 11px rgba(0, 0, 0, .07);
        background:#ffffff;
    }

    .dropdown-item.active, .dropdown-item:active {
        background: transparent !important;
    }

    .accounts-main-items {
        padding: 15px 0;
    }

    .accounts-submenu:after {
        content: "";
        position: absolute;
        width: 0;
        height: 0;
        margin-left: -0.5em;
        top: 50px;
        right: 18px;
        box-sizing: border-box;
        border: 7px solid black;
        border-color: transparent transparent #fff #fff;
        transform-origin: 0 0;
        transform: rotate(-135deg);
        box-shadow: -3px 3px 3px 0 rgba(0, 0, 0, 0.025);

    }

    .account-menu-item.open-accounts .accounts-submenu-wrapper{
        display: block;
        opacity:1;
    }

    .accounts-dropdown .dropdown-menu {
        padding: 0;
        top: calc(100% + 15px);
        border: 0;
        box-shadow: 1px 5px 11px rgba(0, 0, 0, .1);
        font-size: 14px;
    }

    .accounts-dropdown .dropdown-menu .account-menu-item > .dropdown-item:after{
        content: "";
        position: absolute;
        width: 0;
        height: 0;
        top: 0px;
        right:0;
        right: calc(3rem - 13px);
        box-sizing: border-box;
        border: 7px solid black;
        border-color: transparent transparent #fff #fff;
        transform-origin: 0 0;
        transform: rotate(135deg);
        box-shadow: -3px 3px 3px 0 rgba(0, 0, 0, 0.025);
    }

    .accounts-dropdown .dropdown-menu .account-menu-item > .dropdown-item:hover:after {
        border-color: transparent transparent #f8f9fa #f8f9fa;
    }

    .accounts-submenu-wrapper .listed-accounts {
        max-height: 120px;
        overflow-y: scroll;
        padding: 15px 0;
    }

    .btn-dark {
        color: #fff;
        background-color: #296A9B !important;
        border-color: #343a40;
    }

    .accounts-submenu-header {
        padding: .25rem 1.5rem;
        min-height: 80px;
        border-bottom: 1px solid #eaeaea;
        font-size: 1rem;
    }

    .account-menu-item {
        cursor: pointer;
        min-height: 80px;
        border-bottom: 1px solid #eaeaea;
    }

    .account-menu-item p {
        line-height: 1em;
    }

    .account-role {
        font-size: 12px;
        line-height: 1em;
        color: #4db14d;
    }

    .account-email {
        font-size: 12px;
        line-height: 1em;
        color: darkgrey;
    }

    .account-show:after{
        display: inline-block;
        width: 0;
        height: 0;
        margin-left: .255em;
        vertical-align: .255em;
        content: "";
        border-top: .3em solid;
        border-right: .3em solid transparent;
        border-bottom: 0;
        border-left: .3em solid transparent;
        color:lightgrey;
        transform:rotate(-90deg) translateY(10px);

    }

    /*===========================
      Navigation Responsive
    ===========================*/

    @media (max-width:991px){

        .navbar-brand{
            padding: 0;
            width: 110px;
            margin: 0;
        }

        .account-image{
            width:40px;
        }

        .navbar-brand img{
            max-width:100%;
        }
        .main-menu-dropdown,
        .accounts-dropdown{
            position:static;
        }

        .main-menu-dropdown .dropdown-menu-left{
            position: absolute;
            right: 20px;
            left: 20px;
            top: calc(100% + 10px); border: 0;
            box-shadow: 1px 5px 11px rgba(0, 0, 0, .07);

        }

        .accounts-dropdown .dropdown-menu-right{
            position: absolute;
            right: 20px;
            /* width: 100%; */
            left: 20px;
            top: calc(100% + 10px);
        }

        .accounts-submenu{
            position:relative;
            overflow: hidden;
        }

        .accounts-submenu:before{
            top:50px;
            content:'';
            box-shadow: inset 0 0 9px 2px rgba(0 ,0 ,0 , 0.08);
            position:absolute;
            bottom:0;
            right:-10px;
            left:-10px;
            pointer-events: none;
        }

        .accounts-submenu:after{
            display:none;
        }

        .accounts-submenu-wrapper .listed-accounts {
            min-height: 180px;
        }

        .accounts-submenu-wrapper{
            position: relative;

            left: auto;
            width: 100%;
            padding: 0;
        }

        .accounts-submenu-wrapper .accounts-submenu{
            box-shadow:none;
            padding:0;
        }

        .accounts-submenu-header {
            padding: .25rem 1.5rem;
            min-height: 50px;
            border-bottom: 1px solid #eaeaea;
            font-size: 1rem;
            border-top: 1px solid #eaeaea;
        }
    }

    /* customizations */

</style>


